import React from 'react';
import { connect } from "react-redux";
import RxNumber from "../common/RxNumber";
import * as Tools from "../../helpers/Tools";
import DatePicker from "../common/DatePicker";
import * as types from "../../constants/actionTypes";
import MiniSpinner from '../common/MiniSpinner';
import Spinner from "../common/spinner";
import StatusBanner from '../common/StatusBanner';
import { logUI } from "../../api/andyliticsApi";

const rxNumberInputId = 'rxNumberInput';
const dobInputId = "dobInput";

class PharmacyNotFound extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rNumber: "",
            isrNumberValid: true,
            isdateOfBirthValid: true,
            dateOfBirth: "",
            validDob: true,
            showMessage: false,
            countOfLinkPharmacyError: 0
        };

        this.validateForm = this.validateForm.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.rxLinkingCallback = this.rxLinkingCallback.bind(this);
        this.onGotItClick = this.onGotItClick.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.Rx.Proxy.PharmacyNotFound.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    isRxNumber(field) {
        const rxNumberPattern = /^((\d+)?(-{1})?\d+)+$/;
        return field.trim() && rxNumberPattern.test(field);
    }

    isValidate(value) { //call this to validate date before going further to next page.
        let dateOfBirth = value;
        let validDob;
        validDob = this.isValidDate(dateOfBirth);//check valid date instead of length, this is required as isValid on input change is not actually validating.
        if (validDob !== this.state.validDob) {
            this.setState({ validDob });
        }
        if (!validDob) this.inputId = dobInputId;
        return validDob;
    }

    isValidDate(dateValue) {
        const dateToday = new Date();
        const minDate = new Date(dateToday.setFullYear(dateToday.getFullYear() - 140));
        return (!minDate || Tools.dateStringFormat(dateValue) >= Tools.dateStringFormat(minDate)) && (Tools.dateStringFormat(dateValue) <= Tools.dateStringFormat(new Date()));
    }

    stupidDatePickerHack(dt) {
        // turn a string containing YYYY-MM-DD into one containing MM/DD/YYYY
        let parts = dt.split('-');
        return parts && parts.length > 1 ? `${parts[1].toString().padStart(2, "0")}/${parts[2].toString().padStart(2, "0")}/${parts[0]}` : null;
    }

    onInputChange(field, value, isValid) {
        var isValidField = true;
        switch(field) {
            case "rNumber":
                isValidField = value !== "" && value !== "undefined" ? this.isRxNumber(value) : false;
                break;
            case "dateOfBirth":
                isValidField = typeof isValid === 'undefined' || isValid ? this.isValidate(value) : false;
                break;
            default:
                isValidField =  true;
        }
        this.setState({ [field]: value, [`is${field}Valid`]: isValidField });
    }

    validateForm() {
        const { rNumber, dateOfBirth, countOfLinkPharmacyError } = this.state;
        const { link, userDetails } = this.props;
        var isdateOfBirthValid = dateOfBirth !== "" && dateOfBirth !== "undefined" ? this.isValidate(dateOfBirth) : false;
        var isrNumberValid = rNumber !== "" && rNumber !== "undefined" ? this.isRxNumber(rNumber) : false;
        this.setState({ isdateOfBirthValid: isdateOfBirthValid, isrNumberValid: isrNumberValid });
        
        if (isrNumberValid && isdateOfBirthValid) {
            if (this.props.setInPharmacyNotFound)
                this.props.setInPharmacyNotFound(true);
            logUI("MBHWeb.Rx.Proxy.PharmacyNotFound.VerifyAndLink", new Date(), Tools.getURLPath());
            link(userDetails, rNumber, dateOfBirth, this.rxLinkingCallback);
            this.setState({ showMessage: true });
            this.setState({ countOfLinkPharmacyError: countOfLinkPharmacyError + 1 });
        }
        return false;
    }

    rxLinkingCallback(linkedAccount) {
        if (linkedAccount && this.props.onLinked) {
            logUI("MBHWeb.Rx.Proxy.PharmacyNotFound.VerifyAndLinkCallback", new Date(), Tools.getURLPath());
            this.props.setInPharmacyNotFound(true);
            this.props.onLinked(this.state.dateOfBirth);
        }
    }

    onGotItClick() {
        const { successMessage } = this.props;
        if (successMessage && this.props.gotItCallback) {
            logUI("MBHWeb.Rx.Proxy.PharmacyNotFound.GotIt", new Date(), Tools.getURLPath());
            this.props.gotItCallback();
        }
    }

    render() {
        const { rxDown, linking, errorMessage, successMessage, technicalHelpDeskNumber, technicalHelpDeskHours , proxyRequesteeInfo } = this.props;
        const { rNumber, dateOfBirth, isrNumberValid, isdateOfBirthValid, showMessage, countOfLinkPharmacyError } = this.state;
        const dateToday = new Date();
        const minDate = dateToday.setFullYear(dateToday.getFullYear() - 140);

        const heading = proxyRequesteeInfo && proxyRequesteeInfo === "rx-request" ? "Please link your BSW pharmacy to proceed with this request." : "Please link your BSW pharmacy to accept this request.";

        return (<div className="container-fluid body-content no-pharmacy-container">
            {linking && countOfLinkPharmacyError > 3 ? <Spinner />
                : !successMessage && showMessage && !linking &&  countOfLinkPharmacyError > 3 ?
                    <div className="no-pharmacy-error-container">
                        <div className="row">
                            <div className="col-12">
                                {<StatusBanner bannerAlignment="left" bannerMsg={`We were unable to link your account.`} failedStatus >
                                    <span>
                                        For assistance, call the MyBSWHealth technical help desk {technicalHelpDeskHours} at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.
                                    </span>
                                </StatusBanner>}
                            </div>
                        </div>
                    </div>
                    : !successMessage  ? <div className="row">
                <div className="col-12">
                    <h1 className="step-heading">{heading}</h1>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <RxNumber rxNumberId={rxNumberInputId} value={rNumber} required placeholder="Active RX Number"
                            onChange={(e, isValid) => { this.onInputChange('rNumber', e.target.value, isValid); }}
                            tooltipID="activeRXToolTip" tooltipMsg="Enter the digits before dash[xxxxxx]-xx from your most recent, active prescription."
                            showAsInvalid={!isrNumberValid}
                        />
                    </div>
                    <div className="form-group">
                        <DatePicker dobId={dobInputId} required value={this.stupidDatePickerHack(dateOfBirth)} yearsBackward={140} maxDate={new Date()} minDate={new Date(minDate)}
                            placeholder="Date Of Birth"
                            onChange={(day, isValid) => {
                                this.onInputChange('dateOfBirth',
                                    !isValid ? '' : `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, "0")}-${day.getDate().toString().padStart(2, "0")}`);
                            }}
                            showAsInvalid={!isdateOfBirthValid}
                        />
                     </div>
                        {linking
                            && <Spinner />
                        }
                            {!successMessage && showMessage && !linking && countOfLinkPharmacyError <= 3 &&
                            <div className="col-12 text-center">
                                <div className="error-msg" dangerouslySetInnerHTML={errorMessage} />
                            </div>}
                    <div className="col-12 text-center">
                        <button className='btn btn-primary' disabled={linking} onClick={this.validateForm}>VERIFY AND LINK</button>
                    </div>
                </div>
            </div>
                : 
                <React.Fragment>
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="step-heading-icon success-heading"><span className="icon-list-check" /></div>
                            <h1 className="step-heading step-heading-md success-heading">Thanks, your pharmacy was linked!</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <button className='btn btn-primary' onClick={this.onGotItClick}>GOT IT</button>
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>);
    }
}

const mapStateToProps = (state) => {
    const { isLinking, linkPharmacyError, linkedAccount } = state.pharmacy;
    let errorMessage = '';
    let successMessage = '';

    if (!isLinking && linkPharmacyError) {
        errorMessage = 'Your pharmacy information could not be verified. Try again.';
    }

    if (!isLinking && linkedAccount) {
        successMessage = "We have successfully linked your BSW pharmacy.";
    }

    return {
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours : "",
        userDetails: state.sso.userDetails,
        rxDown: state.common.rxDown,
        linking: isLinking,
        errorMessage: { __html: errorMessage },
        successMessage: successMessage,
        location: location
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        link: (userDetails, rxNumber, dob, callback) => {
            const data = {
                rxNumber: rxNumber,
                DateOfBirth: dob,
                loginId: userDetails.userName,
                FirstName: userDetails.Givenname,
                LastName: userDetails.Surname
            };
            dispatch({ type: types.LINK_PHARMACY, accountToLink: data, callback });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PharmacyNotFound);